module.exports = __webpack_public_path__ + "img/diplom-top-500-childs.d3430376.png";